import Line from '@FreeRider/Track/Lines/Line';
import PhysicsLine from '@FreeRider/Track/Lines/PhysicsLine';
import SceneryLine from '@FreeRider/Track/Lines/SceneryLine';
import Mass from '@FreeRider/Physics/Mass';
import Powerup from '@FreeRider/Track/Powerups/Powerup';

class Sector
{
    /*-------------------------------------------------------*/
    public physicsLines: PhysicsLine[];
    public sceneryLines: SceneryLine[];
    public powerups: Powerup[];

    public x: number;
    public y: number;

    /**
     * Constructor
     * @param x - sectors x position
     * @param y - sectors y position
     */
    constructor(x: number, y: number)
    {
        this.x = x;
        this.y = y;

        this.physicsLines = [];
        this.sceneryLines = [];
        this.powerups = [];
    }

    /**
     * Adds a object to the sector
     * @param obj
     */
    public addLine(obj: Line)
    {
        if (obj instanceof PhysicsLine)
        {
            this.physicsLines.push(obj);
        }
        else if (obj instanceof SceneryLine)
        {
            this.sceneryLines.push(obj);
        }
    }

    /**
     * Adds a powerup to the sector
     * @param obj
     */
    public addPowerup(obj: Powerup)
    {
        this.powerups.push(obj)
    }

    /**
     * Reset Collided
     */
    public resetCollided()
    {
        const physicsLines = this.physicsLines;

        const physicsLinesCount = physicsLines.length;

        for (let j = physicsLinesCount - 1; j >= 0; j--)
        {
            if (physicsLines[j])
            {
                physicsLines[j].collided = false;
            }
        }
    }

    /**
     * Collide
     * @param mass
     */
    public collide(mass: Mass)
    {
        /*----------------- Lines -----------------*/

        const physicsLines = this.physicsLines;

        const physicsLinesCount = physicsLines.length;

        for (let j = physicsLinesCount - 1; j >= 0; j--)
        {
            if (physicsLines[j])
            {
                var line = physicsLines[j];

                if (line.remove)
                {
                    physicsLines.splice(j, 1);
                }
                else
                {
                    line.collide(mass);
                }
            }
        }

        /*------------- Powerups ----------------*/

        const powerups = this.powerups;

        const powerupsCount = powerups.length;

        for (let p = powerupsCount - 1; p >= 0; p--)
        {
            powerups[p].collide(mass);
        }
    }

}

export default Sector;